import { Store, Umbrella } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function SubCategories() {
  const navigate = useNavigate();

  return (
    <div className="text-black border bg-white rounded-2xl p-6 pt-6 md:w-[920px]">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div
          className="border w-full rounded-lg cursor-pointer hover:bg-red-50 hover:ring ring-red-400 justify-self-center p-4 text-red-900"
          onClick={() => navigate("/insurance/pandc")}
        >
          <Umbrella
            size={20}
            strokeWidth={2.1}
            className="mt-2"
            color="#fb7185"
          />
          <div className="grayscale hover:grayscale-0">
            <div className="text-xl text-left w-full mr-auto mt-2">P&C Insurance</div>
            <div className="text-lg leading-6 opacity-75  text-left w-full mr-auto mt-2 mb-2">
              Get help with property and casualty coverage, claims, and policy
              support. Connect with our agents easily here
            </div>
          </div>
        </div>
        <div
          className="border w-full rounded-lg cursor-pointer hover:bg-amber-50 hover:ring ring-amber-400 justify-self-center p-4 text-amber-900"
          onClick={() => navigate("/insurance/healthcare")}
        >
          <Store size={19} strokeWidth={2.0} className="mt-2" color="#fb923c" />
          <div className="grayscale hover:grayscale-0">
            <div className="text-xl text-left w-full mr-auto mt-2">
              Health Insurance
            </div>
            <div className="text-lg leading-6 opacity-75  text-left w-full mr-auto mt-2 mb-2">
              Explore new plans, get answers about your policy, and renew your
              coverage — our agents are here to help
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
